// src/pages/battle/Battlemap.utils.js

export const getHealthBarColor = (hp, maxHp) => {
  const ratio = hp / maxHp;
  if (ratio > 0.6) return 'bg-green-500';
  if (ratio > 0.3) return 'bg-yellow-500';
  return 'bg-red-500';
};

export const getHealthTextColor = (hp, alertColor) => {
  if (hp <= 2) return alertColor;
  return 'text-green-400';
};

export const getHealthBarBgColor = (hp, alertColor) => {
  if (hp > 3) return 'bg-green-500';
  if (hp > 1) return 'bg-yellow-500';
  return `${alertColor}-bg`;
};

export const calculateHealthPercentage = (hp, maxHp) => {
  return (hp / maxHp) * 100;
};

export const shouldShowAbilityTargeting = (abilityId) => {
  const targetedAbilities = [
    'medkit', 
    'revival_protocol', 
    'deadeye', 
    'disabling_shot', 
    'double_tap', 
    'suppression', 
    'guardian', 
    'holo_targeting', 
    'suppress_fire'
  ];
  return targetedAbilities.includes(abilityId);
};

export const formatAbilityInfo = (ability) => {
  if (ability.currentCooldown > 0) {
    return `CD: ${ability.currentCooldown}`;
  }
  
  let info = `${ability.apCost} AP`;
  if (ability.usesRemaining !== null) {
    info += ` | ${ability.usesRemaining} uses`;
  }
  
  return info;
};

export const getUnitsByType = (units, type) => {
  return units.filter(u => u.type === type && u.hp > 0);
};

export const countCasualties = (squad, soldiers) => {
  return squad.length - soldiers.length;
};